module.exports = __webpack_public_path__ + "media/greenhouse-hd03.e8242e38.mp4";